import { render, staticRenderFns } from "./app-create-todo.vue?vue&type=template&id=74d64764&"
import script from "./app-create-todo.vue?vue&type=script&lang=ts&"
export * from "./app-create-todo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports